import React, { useRef } from "react";
import ContactSupportIcon from "@mui/icons-material/ContactSupport";
import LiveHelpIcon from "@mui/icons-material/LiveHelp";
import FeedbackIcon from "@mui/icons-material/Feedback";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import IwButtonDropdown from "./IwButtonDropdown";
import { Stack } from "@mui/material";
import { Box } from "@mui/system";
import { beaconUtils } from "../../util/beaconUtils";
import useIwProductFruits from "../ProductFruits/useIwProductFruits";
import ProductFruitsChecklistContainer from "../ProductFruits/ProductFruitsChecklistContainer";
import { useTheme } from '@mui/material/styles';

const Beacon = beaconUtils();

const HelpMenuButton = () => {
    const { startQuickStartTour, showInAppTourChecklist } = useIwProductFruits();
    const startChecklistContainerRef = useRef();
    const theme = useTheme();
    const buildMenuItemContent = ({icon, title, subTitle}) => {
        return (
            <Stack
                direction="row"
                alignItems="center"
                spacing={2}
                sx={{
                    padding: "8px 0",
                    ":hover": {
                        ".HelpMenuButton-container": {
                            backgroundColor: theme?.custom?.white,
                        },
                    },
                }}
            >
                <Box
                    className="HelpMenuButton-container"
                    sx={{
                        height: "44px",
                        width: "44px",
                        borderRadius: "50%",
                        backgroundColor: theme?.custom?.disabledColor,
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        ".MuiSvgIcon-root": {
                            fontSize: "24px",
                            color: theme?.custom?.mainIconColor,
                        },
                    }}
                >
                    {icon}
                </Box>
                <Stack>
                    <Box sx={{ fontSize: "14px", fontWeight: 600 }}>{title}</Box>
                    <Box sx={{ fontSize: "12px" }}>{subTitle}</Box>
                </Stack>
            </Stack>
        );
    }

    const dropdownItems = [
        {
            content: (
                <Stack
                    direction="row"
                    alignItems="center"
                    sx={{
                        padding: "0 0 0 6px",
                    }}
                >
                    Need Help?
                </Stack>
            ),
            showInButton: true,
            onClick: () => {
                startQuickStartTour();
            },
        },
        {
            content: buildMenuItemContent({
                icon: <ContactSupportIcon />,
                title: "Chat with Support",
                subTitle: "Connect instantly with our team.",
            }),
            onClick: () => {
                Beacon.navigate("/ask/chat/");
            },
            shouldCloseMenuOnClick: true,
        },
        {
            content: buildMenuItemContent({
                icon: <LiveHelpIcon />,
                title: "In-App Tours",
                subTitle: "View all of our In-App guides.",
            }),
            onClick: () => {
                showInAppTourChecklist(startChecklistContainerRef);
            },
            shouldCloseMenuOnClick: true,
        },
        {
            content: buildMenuItemContent({
                icon: <FeedbackIcon />,
                title: "Leave Feedback",
                subTitle: "Share feedback and bug reports.",
            }),
            onClick: () => {
                Beacon.navigate("/ask/message/");
            },
            shouldCloseMenuOnClick: true,
        },
        {
            content: buildMenuItemContent({
                icon: <MenuBookIcon />,
                title: "Visit Help Center",
                subTitle: "Access our help articles.",
            }),
            onClick: () => {
                Beacon.navigate("/");
            },
            shouldCloseMenuOnClick: true,
        },
    ];

    return (
        <>
            <Box sx={{ marginRight: "8px !important" }}>
                <IwButtonDropdown
                    dropdownItems={dropdownItems}
                    shape="rounded"
                    slotProps={{
                        // @ts-ignore
                        menu: {
                            slotProps: {
                                paper: {
                                    sx: {
                                        minWidth: "300px",
                                    },
                                },
                            },
                        },
                    }}
                />
            </Box>
            <ProductFruitsChecklistContainer ref={startChecklistContainerRef} />
        </>
    );
};

export default HelpMenuButton;
